// *******************************************************************************
// 1.0 - Form Validation
// *******************************************************************************
const succesfull = false;
document.addEventListener('DOMContentLoaded', () => {
  const formModule = document.querySelector('.contact-form');
  const formElem = document.getElementById('help-form');
  if (formElem) {
    const fv = FormValidation.formValidation(formElem, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input , .checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input , .checkbox');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': !e.valid && value === '',
        });
      })
      .on('core.form.valid', () => {
        const formData = {};
        const formDataImage = new FormData();
        const form = document.querySelector('.contact-form form');

        form.querySelectorAll('input, textarea').forEach((input) => {
          if (input.type === 'checkbox') {
            formData[input.name] = input.checked;
          } else {
            formData[input.name] = input.value.trim();
          }
        });
        formDataImage.append('action', formData.action);
        formDataImage.append('inputs', JSON.stringify(formData));
        formDataImage.append('lang', localData.lang);
        formDataImage.append('id', localData.id);
        formDataImage.append('nonce', formData.nonce);
        axios
          .post(localData.siteURL, formDataImage, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            if (response.status === 200) {
              formModule.classList.add('show-thankyou');
              window.scrollTo(0, 0);

              const container = document.querySelector('.user-account');
              const formHeader = formElem.querySelector('.help-form__header');
              formHeader.innerHTML = `<div class="title : title--h2 : "><h2>${response.data.data.msg}</h2></div>`;
              formElem.remove();
              container.appendChild(formHeader);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
  }
});
